export const exportFeatureKey = 'export';

export type FileModel = {
  name: string;
  contentType: string;
  data: string;
};
